import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  Modal,
  ModalBody,
  ModalHeader,
  ModalFooter,
} from '@americanexpress/dls-react';
/* eslint-disable  import/no-cycle -- need */
import { constructChildStructure } from '../ChildConstructor';

const PopUp = (childProps) => {
  const {
    closeButtonLabel = 'close',
    isDismissible = true,
    closeButtonProps = {},
    setShowPopUp,
    showPopUp,
    windowWidth,
    fieldId,
    popUpBodyChildElements = [],
    popUpFooterChildElements = [],
    popUpHeaderChildElements = [],
    props,
    popUpMessage = null,
  } = childProps;
  const { formSubmissionPayload } = props;
  const [show, setShow] = useState(false);

  /* Function to exceute when popUp is visible
   const logger = () => {
     console.log('Hello World');
   };
   */

  useEffect(() => {
    if (showPopUp && showPopUp === fieldId) {
      // if there's a message to show
      setShow(true);
      if (popUpMessage) {
        formSubmissionPayload.popUpMessage = popUpMessage;
      }
    } else {
      setShow(false);
    }
  }, [showPopUp]);

  const closePopUp = () => {
    setShowPopUp('');
    if (popUpMessage) {
      delete formSubmissionPayload.popUpMessage;
    }
  };
  /* eslint-enable  import/no-cycle -- need */
  return (

    show && (
      <Modal
        id={fieldId}
        aria-labelledby={`${fieldId}-modal-header`}
        aria-describedby={`${fieldId}-modal-body`}
        onClose={closePopUp}
        theme={{ '> div': { maxWidth: `${windowWidth || ''}` } }}
      // modalDialogRef={logger}
      >
        {popUpHeaderChildElements.length > 0 && (
          <ModalHeader
            id={`${fieldId}-modal-header`}
            closeButtonLabel={closeButtonLabel}
            dismissible={isDismissible}
            closeButtonProps={closeButtonProps}
          >
            {constructChildStructure(popUpHeaderChildElements, props, fieldId)}
          </ModalHeader>
        )}
        {popUpBodyChildElements.length > 0 && (
          <ModalBody id={`${fieldId}-modal-body`}>
            {constructChildStructure(popUpBodyChildElements, props, fieldId)}
          </ModalBody>
        )}
        {popUpFooterChildElements.length > 0 && (
          <ModalFooter id={`${fieldId}-modal-footer`}>
            {constructChildStructure(popUpFooterChildElements, props, fieldId)}
          </ModalFooter>
        )}
      </Modal>
    )
  );
};

PopUp.propTypes = {
  formSubmissionPayload: PropTypes.func,
};

export default PopUp;
